/**
 * Used to show/hide sections on mobile only (viewport < 600px)
 * Uses the following markup structure:
 *
 * <div class="c-toggle-display js-toggle-display">
 *    <button class="c-toggle-display__btn js-toggle-btn" data-contentsid="js-toggle-contents">Show filters<button>
 *    <div id="js-toggle-contents" class="c-toggle-display__contents js-toggle-contents>
 *        Content/hidden elements goes here....
 *    </div>
 * </div>
 */
const ToggleDisplay = (function () {
  const clickToggleBtn = (e) => {
    const toggleBtn = e.target
    const contentsSelector = toggleBtn.dataset.contentsid
    const toggleContents = document.getElementById(contentsSelector)

    if (toggleBtn && toggleContents) {
      if (toggleBtn.classList.contains('c-toggle-display__btn--active')) {
        toggleBtn.classList.remove('c-toggle-display__btn--active')
        toggleBtn.innerHTML = toggleBtn.innerHTML.replace('Hide', 'Show')
        toggleContents.classList.remove('c-toggle-display__contents--active')
      } else {
        toggleBtn.classList.add('c-toggle-display__btn--active')
        toggleBtn.innerHTML = toggleBtn.innerHTML.replace('Show', 'Hide')
        toggleContents.classList.add('c-toggle-display__contents--active')
      }
    }
  }

  const initToggles = () => {
    const toggleEls = document.querySelectorAll('.js-toggle-display')
    toggleEls.forEach((toggleEl) => {
      const toggleBtn = toggleEl.querySelector('.js-toggle-btn')
      if (toggleBtn) {
        toggleBtn.addEventListener('click', clickToggleBtn)
      }
    })
  }

  const killToggles = () => {
    const toggleEls = document.querySelectorAll('.js-toggle-display')
    toggleEls.forEach((toggleEl) => {
      const toggleBtn = toggleEl.querySelector('.js-toggle-btn')
      if (toggleBtn) {
        toggleBtn.removeEventListener('click', clickToggleBtn)
      }
    })
  }

  return {
    init: () => {
      initToggles()
    },
    kill: () => {
      killToggles()
    },
  }
})()

export default ToggleDisplay
